import sha256 from 'crypto-js/sha256';

export const transToSha256String = (v: string) => {
  return sha256(v).toString();
};
